import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../cn";

export type RadioProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type="radio"
      className={cn(
        "border-charcoal/30 text-saffron h-5 w-5 cursor-pointer",
        "focus-visible:ring-saffron focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...rest}
    />
  );
});
